import React from "react";
import { Link } from "react-router-dom";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";

export default function NotFound() {
  return (
    <div className="bg-[#0E1A2B] min-h-screen flex flex-col">
      <Header />
      <main
        data-testid="page-404"
        className="flex-1 flex items-center justify-center px-6"
        style={{ paddingTop: "calc(8rem + var(--promo-banner-h, 0px))" }}
      >
        <div className="text-center max-w-xl">
          <p className="text-[11px] tracking-[0.4em] uppercase text-[#C9A869] mb-5">Erreur 404</p>
          <h1 className="serif font-light text-5xl md:text-6xl text-[#F7F3EA] tracking-tight leading-[1.1] mb-6">
            Cette page <span className="italic gold-text">n'existe pas</span>.
          </h1>
          <p className="text-base text-[#F7F3EA]/70 font-light mb-10">
            Le lien semble cassé ou la page a été déplacée. Retrouvez tout ce qu'il faut savoir sur les cours en revenant à l'accueil.
          </p>
          <Link
            to="/"
            data-testid="404-back-home"
            className="inline-flex items-center gap-3 px-8 py-4 bg-[#C9A869] text-[#0E1A2B] text-[12px] tracking-[0.25em] uppercase font-medium hover:bg-[#DCC28E] transition-colors duration-500"
          >
            Retour à l'accueil
          </Link>
        </div>
      </main>
      <Footer />
    </div>
  );
}
